<template>
  <div>
    <div class="mb-3">
      <div class="row m-0">
        <div class="col-md-4 p-0">
          <template v-if="dialogsLoading">
            <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>
          </template>
          <template v-else>
            <template v-if="dialogs && dialogs.length">
              <ChatList
                :dialogs="dialogs"
                :users="users"
                :displayDetails="{'orderId': true,'author': $currentRole === 'admin' || $currentUserRoles.includes('manager')}"
                :onSelect="onSelectDialog"
                :selectedDialogId="selectedDialog && selectedDialog.id"
              />
            </template>
            <template v-else>
              <div class="alert alert-info">
                <p>У Вас нет активных диалогов</p>
              </div>
            </template>
          </template>
        </div>
        <div class="col-md-8 p-0 all_messages_block" v-if="dialogs && dialogs.length">
          <template v-if="selectedDialog && selectedDialog.id">
            <div v-if="selectedDialog" class="object_info">
              <div>
                <template v-if="selectedDialog.object_id">
                  <p>Заявка <strong>{{ selectedDialog.object_id }}</strong>
                    <button
                      @click="orderToEdit(selectedDialog.object_id)"
                      class="btn btn-xs btn-info ml-1 mr-2"
                    >
                      <i class="icon-fa icon-fa-eye"></i>
                    </button>
                    <strong>{{ selectedDialog.order.project_label }}</strong>
                    {{
                      $AllCities[selectedDialog.order.city_id] && $AllCities[selectedDialog.order.city_id].short_name || selectedDialog.order.city_id
                    }}
                    <span v-bind:class="{
                    'badge': true,
                    'badge-warning': selectedDialog.order.status < 0,
                    'badge-info': selectedDialog.order.status >= 0,
                  }">{{ selectedDialog.order.status_label }}</span>
                  </p>
                </template>
              </div>
              <div>
                <LoadingButton
                  v-if="allowToClose"
                  title="Решено"
                  type="button"
                  :loading="btnLoading"
                  :color="$constants.SUCCESS_COLOR"
                  :onClick="() => acceptDialog(true)"
                  className="btn btn-outline-success"
                />
              </div>
            </div>
            <Messages v-if="selectedDialog && selectedDialog.id && activeMessages"
                      :users="users"
                      :allowToClose="+selectedDialog.user_id === $currentUID"
                      :dialogId="selectedDialog.id"
                      :dialogAccepted="+selectedDialog.user_id === $currentUID || !!selectedDialog.is_accepted"
                      :messages="activeMessages"
            />
          </template>
          <template v-else>
            <center><h4>Выберите запрос</h4></center>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import ChatList from "./components/ChatList"
import Messages from "./components/Messages"
import {chatUpdated} from "@/eventsBus";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {
    ChatList,
    Messages,
    LoadingButton,
  },
  data() {
    return {
      users: null,
      selectedDialog: {},
      dialogs: null,
      myDialogs: null,
      openDialogs: null,
      activeMessages: null,
      dialogsLoading: true,
      dialogLoading: false,
      allowToClose: false,
      btnLoading: false,
    }
  },
  computed: {
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
  },
  created() {
    this.getActiveChats()
    chatUpdated.$on("updateChat", (data) => {
      const dialogIndex = this.dialogs.findIndex((d) => +d.id === +data.dialog_id);
      if (dialogIndex !== -1) {
        if (data.messages) {
          this.dialogs[dialogIndex].messages = data.messages;
          if (+data.showNotification) {
            toastr['info']('Новое сообщение', 'Уведомления');
            this.sendSoundNotification();
          }
        }
        if (data.dialog) {
          this.dialogs[dialogIndex] = {...this.dialogs[dialogIndex], ...data.dialog}
        }
        this.dialogs = this.dialogs.filter((d) => d && +d.is_active);
        const activeDialog = this.dialogs.find((d) => +d.id === (this.selectedDialog && this.selectedDialog.id))
        if (activeDialog) {
          this.onSelectDialog(activeDialog.id);
        }
      }
    });
  },
  methods: {
    sendSoundNotification() {
      if (this.$userSettings && this.$userSettings.webSettings && !!this.$userSettings.webSettings.notificationSound) {
        const audio = new Audio(
          "https://admin.rancond.info/assets/audio/notifications/icq.mp3"
        );
        try {
          audio.play();
        } catch (e) {
          console.log(e);
        }
      }
    },
    async acceptDialog(close = false) {
      this.btnLoading = true;
      const {data} = await api.post('/new/chat/update', {
        type: close ? 'closeDialog' : 'acceptDialog',
        dialog_id: this.selectedDialog.id,
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка');
      } else {
        this.dialogs = this.dialogs.filter((d) => +d.id !== +this.selectedDialog.id)
        this.selectedDialog = null;
      }
      this.btnLoading = false;
    },
    orderToEdit(id, dialog = null) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id, dialog: {...dialog, messages: this.activeMessages}});
    },
    onSelectDialog(dialogId) {
      this.allowToClose = false;
      const dialog = this.dialogs.find((d) => +d.id === +dialogId);
      this.selectedDialog = dialog;
      this.activeMessages = dialog && +dialog.is_active ? dialog.messages : null;
      if (dialog && +dialog.is_active) {
        if (this.$currentUserRoles.includes('supervisor')) {
          this.allowToClose = true;
        } else {
          if ([1, 4].includes(dialog.type_id)) { // free question from runner
            if (this.$currentUserRoles.includes('manager') || this.$currentUserRoles.includes('managerAssist')) {
              this.allowToClose = true;
            }
          } else {
            this.allowToClose = dialog.user_id === +this.$currentUID;
          }
        }
        if ([-2, -3].includes(+this.selectedDialog.order.status)) this.allowToClose = true;
      }
    },
    async getActiveChats() {
      this.dialogsLoading = true;
      this.selectedDialog = null;
      const {data} = await api.index('/new/chat/mychats')
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка загрузки');
      } else {
        this.users = data.users;
        this.dialogs = data.dialogs;
      }
      this.dialogsLoading = false;
    }
  }
}

</script>

<style scoped>
.object_info {
  border: 1px solid lightgray;
  border-bottom: none;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}

.object_info p {
  margin-bottom: 0;
}

.all_messages_block {
  height: 65vh;
  overflow: hidden;
}
</style>
